import React from "react";

const Error = () => {
  return <div>ERROR 404 </div>;
};

export default Error;
